<template>
  <div id="maxBox">
    <el-dialog title="2025年春节放假通知" :visible.sync="this.isshow" :show-close="false" :before-close="endUp" width="900px"
      center>
      <div style="font-size:18px;">
        <p>尊敬的用户：</p>
        <p style="text-indent: 2em">平台根据国家节假日放假规定，结合公司实际情况，研究决定：</p>
        <p style="text-indent: 2em">公司放假安排：2025年1月28日--2月4日</p>
        <p style="text-indent: 2em">正式上班时间：2月5日</p>
        <p style="text-indent: 2em;color:#ff0000">放假期间如需咨询可留言客服，客服看到后将在上班后第一时间回复您，由此带来的不便，敬请谅解！</p>
        <p style="text-align:right;margin-top:10px;">河北筑正科技有限公司</p>
        <!-- <p style="text-align:right;"> 2024年9月25日</p> -->
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonUpBox",

  data() {
    return {
      img: require("@/assets/Dragon Boat Festival.png"),
      isshow: false,
      newTime: "", //拼年月日
      year: null,
      month: null,
      strDate: null,
    };
  },

  created() { },
  mounted() {
    //判断当前时间
    let data = new Date();
    let year = data.getFullYear();
    var month = data.getMonth() + 1; // 获取月
    var strDate = data.getDate(); // 获取日
    let bod = `${year}${this.bu(month)}${this.bu(strDate)}`;
    //是否超过设定时间
    if (bod >= 20250205) {
      this.endTime(); //超时隐藏
    } else {
      //
      this.getTime();
    }
  },

  methods: {
    bu(a) {
      return a > 9 ? a : "0" + a;
    },
    endTime() {
      this.isshow = false;
    },
    getTime() {
      let id = setInterval(() => {
        let data = new Date();
        this.year = data.getFullYear();
        this.month = data.getMonth() + 1; // 获取月
        this.strDate = data.getDate(); // 获取日
        this.newTime = `${this.year}年${this.month}月${this.strDate}日`;
        this.isshow = true;
        clearInterval(id);
      }, 100);
    },
    endUp() {
      this.isshow = false;
    },
  },
};
</script>

<!-- <style lang="less" scoped>
.top {
  font-size: 34px;
  font-weight: bold;
  text-align: center;
}

.End {
  float: right;
  color: gray;
  font-weight: 100;
  font-size: 30px;
  cursor: pointer;
  line-height: 40px;
}

.zhezhao {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 9998;
}

.upBox {
  width: 100%;
  height: 80vh !important;
  position: fixed;
  border: 1px solid white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 560px;
  z-index: 9999;
}

.main,
.bottom {
  font-size: 20px;
  font-family: "行楷";
}

/deep/ .el-dialog__header {
  display: none;
}

/deep/ .el-dialog {
  background-color: transparent;
  border: none;
  box-shadow: 0px 0px 0px 0px;
}

/deep/ .el-dialog__body {
  padding: 0;
} 
</style>-->
